import React from "react";

const NotesContiner =(props)=>(
    <div className="note">
        {props.children}
    </div>

)

export default NotesContiner;